module.exports = __webpack_public_path__ + "img/mobile/SmartButton-auto/auto_bg_portrait@2x.png?0.0.53";